module.exports = __webpack_public_path__ + "static/dining4-a3bb81bfc7baf6d445d00d2b8d75b73f.jpg";